"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Km = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 500 300", ...props },
    react_1.default.createElement("path", { fill: "#3A75C4", d: "M0 0h500v300H0z" }),
    react_1.default.createElement("path", { fill: "#CE1126", d: "M0 0h500v225H0z" }),
    react_1.default.createElement("path", { fill: "#FFF", d: "M0 0h500v150H0z" }),
    react_1.default.createElement("path", { fill: "#FFC61E", d: "M0 0h500v75H0z" }),
    react_1.default.createElement("path", { fill: "#3D8E33", d: "m0 300 250-150L0 0v300z" }),
    react_1.default.createElement("circle", { cx: 85, cy: 150, r: 67.5, fill: "#FFF" }),
    react_1.default.createElement("circle", { cx: 115, cy: 150, r: 67.5, fill: "#3D8E33" }),
    react_1.default.createElement("path", { id: "km_svg__a", fill: "#FFF", d: "m100.01 89.2 7.36 22.588-19.258-13.949h23.776L92.63 111.788l7.38-22.588z" }),
    react_1.default.createElement("use", { xlinkHref: "#km_svg__a", y: 32.208 }),
    react_1.default.createElement("use", { xlinkHref: "#km_svg__a", y: 64.417 }),
    react_1.default.createElement("use", { xlinkHref: "#km_svg__a", y: 96.625 })));
exports.default = Km;
//# sourceMappingURL=Km.js.map